var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(-1 0 0 -1 558.698 -774.781)",
    gradientUnits: "userSpaceOnUse",
    x1: 206.639,
    x2: 206.639,
    y1: -1224.396,
    y2: -1167.894
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(-1 0 0 -1 558.698 -774.781)",
    gradientUnits: "userSpaceOnUse",
    x1: 400.757,
    x2: 400.757,
    xlinkHref: "#lg1",
    y1: -1235.691,
    y2: -1202.241
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(-1 0 0 -1 558.698 -774.781)",
    gradientUnits: "userSpaceOnUse",
    x1: 245.357,
    x2: 245.357,
    y1: -1231.347,
    y2: -1155.303
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e08e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fa953"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843561"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(-1 0 0 -1 558.698 -774.781)",
    gradientUnits: "userSpaceOnUse",
    x1: 362.04,
    x2: 362.04,
    xlinkHref: "#lg2",
    y1: -1212.232,
    y2: -1142.852
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(-1 0 0 -1 558.698 -774.781)",
    gradientUnits: "userSpaceOnUse",
    x1: 303.698,
    x2: 303.698,
    y1: -1245.248,
    y2: -1169.224
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45a2e0"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(-1 0 0 -1 558.698 -774.781)",
    gradientUnits: "userSpaceOnUse",
    x1: 226.244,
    x2: 226.244,
    y1: -1175.306,
    y2: -1146.93
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff755c"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(-1 0 0 -1 558.698 -774.781)",
    gradientUnits: "userSpaceOnUse",
    x1: 263.523,
    x2: 263.523,
    y1: -1178.89,
    y2: -1121.864
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43765a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(-1 0 0 -1 558.698 -774.781)",
    gradientUnits: "userSpaceOnUse",
    x1: 303.698,
    x2: 303.698,
    y1: -1176.61,
    y2: -1095.105
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#174461",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174461"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2f4d"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(-1 0 0 -1 558.698 -774.781)",
    gradientUnits: "userSpaceOnUse",
    x1: 343.873,
    x2: 343.873,
    xlinkHref: "#lg3",
    y1: -1163.232,
    y2: -1135.228
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(-1 0 0 -1 558.698 -774.781)",
    gradientUnits: "userSpaceOnUse",
    x1: 381.152,
    x2: 381.152,
    xlinkHref: "#lg3",
    y1: -1178.239,
    y2: -1129.99
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.751,
    x2: 180.937,
    xlinkHref: "#lg2",
    y1: 277.404,
    y2: 315.452
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 352.889,
    x2: 391.542,
    xlinkHref: "#lg2",
    y1: 285.751,
    y2: 344.937
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.442,
    x2: 273.244,
    y1: 189.925,
    y2: 189.925
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.271,
    x2: 101.537,
    xlinkHref: "#lg4",
    y1: 174.242,
    y2: 109.017
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.499,
    x2: 225.379,
    xlinkHref: "#lg4",
    y1: 249.506,
    y2: 142.385
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.027,
    x2: 269.818,
    y1: 152.509,
    y2: 187.3
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edf5ff"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9da6ac"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.468,
    x2: 293.224,
    xlinkHref: "#lg5",
    y1: 146.475,
    y2: 210.23
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(-.972 .236 -.236 -.972 -673.74 -613.29)",
    gradientUnits: "userSpaceOnUse",
    x1: -738.888,
    x2: -684.234,
    xlinkHref: "#lg5",
    y1: -1004.307,
    y2: -949.653
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 308.292,
    y2: 340.955
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(0 1 -1 0 -633.016 135.542)",
    gradientUnits: "userSpaceOnUse",
    x1: 216.244,
    x2: 240.808,
    xlinkHref: "#lg1",
    y1: -888.016,
    y2: -888.016
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m328.29 457.893 25.107 52.107h20.284c12.338 0 19.47-13.993 12.22-23.976l-16.358-22.524c-15.365-21.156-23.64-46.632-23.64-72.779v-17.648l-30.594-17.534v42.112c0 21.642 4.544 42.73 12.981 60.242z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.319 510h20.284l25.106-52.107c8.438-17.512 12.982-38.599 12.982-60.242v-42.112l-30.594 17.534v17.648c0 26.147-8.275 51.623-23.64 72.78l-16.357 22.523c-7.25 9.983-.119 23.976 12.219 23.976z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.286 397.65c0 21.643 1.378 42.73 3.936 60.242l7.613 52.108h68.562l-25.106-52.107c-8.438-17.512-12.982-38.599-12.982-60.242v-42.112l-42.023-24.084z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.71 457.893-25.107 52.107h68.562l7.612-52.107c2.558-17.512 3.936-38.599 3.936-60.242v-66.196l-42.023 24.084v42.112c.001 21.642-4.543 42.73-12.98 60.242z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.714 397.65c0 21.643-1.378 42.73-3.936 60.242l-7.613 52.108h59.669l-7.612-52.107c-2.558-17.512-3.936-38.599-3.936-60.242v-66.196l-18.286-10.481-18.286 10.48z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.903 390.72v-17.648l-30.594-17.534v42.112c0 7.813.601 15.55 1.755 23.077h32.536c-2.438-9.758-3.697-19.83-3.697-30.007z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.309 397.65v-42.112l-42.023-24.084v66.196c0 7.813.182 15.55.532 23.077h43.245c-1.153-7.526-1.754-15.264-1.754-23.077z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.818 420.727c-.35-7.526-.532-15.264-.532-23.077v-66.196l-18.286-10.48-18.286 10.48v66.196c0 7.813-.182 15.55-.532 23.077z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.182 420.727c.35-7.526.532-15.264.532-23.077v-66.196l-42.023 24.084v42.112c0 7.813-.601 15.55-1.755 23.077z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.937 420.727c1.154-7.526 1.755-15.264 1.755-23.077v-42.112l-30.594 17.534v17.648c0 10.176-1.259 20.249-3.696 30.007z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m171.039 361.092v-158.534l-56.155 56.155c-23.899 23.899-37.326 56.314-37.326 90.113 0 6.774 5.492 12.266 12.266 12.266z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.961 361.092v-158.534l56.155 56.155c23.9 23.899 37.326 56.314 37.326 90.113 0 6.774-5.492 12.266-12.266 12.266z",
    fill: "url(#SVGID_12_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m223.601 14.498c-41.623 48.851-64.483 110.93-64.483 175.108v190.244h191.765v-190.245c0-64.178-22.861-126.257-64.483-175.108-16.471-19.33-46.329-19.33-62.799.001z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.883 379.849v-190.244c0-64.178-22.861-126.257-64.483-175.108-8.236-9.664-19.818-14.497-31.4-14.497v379.849z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.809 125.722c-27.064 27.064-28.877 68.227-1.813 95.291l144.887 144.8v-176.208c0-6.871-.278-13.715-.797-20.524l-46.079-46.079c-27.065-27.064-69.134-24.344-96.198 2.72z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 254.717,
    cy: 172.199,
    fill: "url(#SVGID_16_)",
    r: 51.252
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m304.007 123.002c-27.064-27.064-70.946-27.064-98.01 0s-27.064 70.946 0 98.01 70.941 27.059 98.005-.005 27.069-70.94.005-98.005zm-82.298 82.298c-18.39-18.39-18.384-48.201 0-66.585 18.39-18.39 48.195-18.39 66.585 0 18.384 18.384 18.39 48.195 0 66.585-18.385 18.384-48.201 18.384-66.585 0z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.902 121.264c-28.025-17.066-64.577-8.182-81.643 19.843s-8.178 64.571 19.847 81.636c28.019 17.062 64.567 8.184 81.632-19.841s8.183-64.576-19.836-81.638zm-55.387 90.957c-22.213-13.526-29.248-42.495-15.726-64.701 13.526-22.213 42.489-29.252 64.701-15.726 22.206 13.522 29.252 42.489 15.726 64.701-13.522 22.206-42.495 29.248-64.701 15.726z",
    fill: "url(#SVGID_18_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m159.117 291.985h191.765v57.978h-191.765z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.64 384.15h186.72c5.737 0 10.388-4.651 10.388-10.388v-33.32c0-5.737-4.651-10.388-10.388-10.388h-186.72c-5.737 0-10.388 4.651-10.388 10.388v33.32c-.001 5.737 4.65 10.388 10.388 10.388z",
    fill: "url(#SVGID_20_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.7bb4c27f0ccd55e10ac81b1cb5c70e0b.svg";
export { ForwardRef as ReactComponent };